import type { AppliedEvidenceRule } from './dailyOverrideTypes'

const STORAGE_PREFIX = 'kilo_evidence_seen_'

function storageKey(dateId: string): string {
  return `${STORAGE_PREFIX}${dateId}`
}

/** Stable id for a Kilo evidence reason — updates when action summary changes. */
export function evidenceReasonFingerprint(rule: AppliedEvidenceRule): string {
  return `${rule.rule_key}:${rule.action_summary}`
}

function loadSeenFingerprints(dateId: string): Set<string> {
  try {
    const raw = localStorage.getItem(storageKey(dateId))
    if (!raw) return new Set()
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.filter((v): v is string => typeof v === 'string'))
  } catch {
    return new Set()
  }
}

function saveSeenFingerprints(dateId: string, seen: Set<string>): void {
  try {
    localStorage.setItem(storageKey(dateId), JSON.stringify([...seen]))
  } catch {
    /* ignore quota / private mode */
  }
}

export function countNewEvidenceReasons(
  dateId: string,
  evidence: AppliedEvidenceRule[],
): number {
  if (evidence.length === 0) return 0
  const seen = loadSeenFingerprints(dateId)
  return evidence.filter((rule) => !seen.has(evidenceReasonFingerprint(rule))).length
}

export function markEvidenceReasonsSeen(
  dateId: string,
  evidence: AppliedEvidenceRule[],
): void {
  if (evidence.length === 0) return
  const seen = loadSeenFingerprints(dateId)
  for (const rule of evidence) {
    seen.add(evidenceReasonFingerprint(rule))
  }
  saveSeenFingerprints(dateId, seen)
}
